const validMp4Regex = /\.mp4$/;

const validMp4 = (mp4: string): boolean => validMp4Regex.test(mp4);

export default validMp4;
